export const UploadFormDeliveryFormTestIds = {
  FILE_UPLOAD: 'upload-form-delivery-form.file-upload',
  SENT_DATE: 'upload-form-delivery-form.sent-date',
  E_SIGNED_DATE: 'upload-form-delivery-form.e-signed-date',
  BUNDLE_UNAVAILABLE_ALERT: 'upload-form-delivery-form.bundle-unavailable-alert',
  SUBMIT_BUTTON: 'upload-form-delivery-form.submit-button',
};
